import { Selection } from './ListItem.types.js';

var getTextColor = function getTextColor(disabled, type) {
  if (disabled) {
    return 'base.disabled';
  }
  if (type && type.type === 'select' && type.selection === Selection.selected) {
    return 'product.primary';
  }
  return 'base.default';
};
var getContainerBoxProps = function getContainerBoxProps(disabled, borderRadius) {
  return {
    disabled: disabled,
    borderRadius: borderRadius
  };
};
var getListItemBoxProps = function getListItemBoxProps(disabled, type, gap, props) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: gap,
    disabled: disabled,
    textColor: getTextColor(disabled, type),
    title: props === null || props === void 0 ? void 0 : props.title,
    subTitle: props === null || props === void 0 ? void 0 : props.subTitle,
    leadingAsset: props === null || props === void 0 ? void 0 : props.leadingAsset,
    trailingAsset: props === null || props === void 0 ? void 0 : props.trailingAsset,
    leadingSlot: props === null || props === void 0 ? void 0 : props.leadingSlot,
    contentSlot: props === null || props === void 0 ? void 0 : props.contentSlot,
    trailingSlot: props === null || props === void 0 ? void 0 : props.trailingSlot,
    type: props === null || props === void 0 ? void 0 : props.type
  };
};

export { getContainerBoxProps, getListItemBoxProps };
//# sourceMappingURL=ListItem.mappers.js.map
